import $ from "jquery";

const autoHideDuration = 1500;
const queueDelay = 500;

const bindClose = ($el) => {
  $el.find("[data-close]").click(() => {
    removeSnackbar($el);
  });
};

const removeSnackbar = ($el) => {
  $el
    .find("[data-snackbar]")
    .addClass("tdd-fx tdd-fx--fast tdd-fx--fade-out-down")
    .one("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd", () => {
      $el.remove();
    });
};

const addSnackbar = (innerHtml) => {
  const $snackBox = $("<div />").append(innerHtml);

  $("body").append($snackBox);
  bindClose($snackBox);

  setTimeout(() => {
    removeSnackbar($snackBox);
  }, autoHideDuration);
};

const enqueueSnackbar = (innerHtml) => {
  if (!$("[data-snackbar]").length) {
    addSnackbar(innerHtml);
  } else {
    setTimeout(() => {
      enqueueSnackbar(innerHtml);
    }, queueDelay);
  }
};

export default enqueueSnackbar;
